/**
 * Environment Detection Utilities
 * Handles dynamic URL generation for different environments
 */

export const getEnvironmentInfo = () => {
  const origin = window.location.origin;
  const hostname = window.location.hostname;
  
  return {
    origin,
    hostname,
    isProduction: hostname === 'canvango.com',
    isDevelopment: hostname === 'localhost' || hostname.includes('127.0.0.1'),
    isStaging: hostname.includes('staging') || hostname.includes('vercel.app'),
  };
};

export const getAuthRedirectUrl = (path: string = '/auth/confirm') => {
  const env = getEnvironmentInfo();
  
  // Production - use HTTPS with proper domain
  if (env.isProduction) {
    return `https://canvango.com${path}`;
  }
  
  // Development - use current origin
  if (env.isDevelopment) {
    return `${env.origin}${path}`;
  }
  
  // Staging or other environments
  return `${env.origin}${path}`;
};

export const getSiteUrl = () => {
  const env = getEnvironmentInfo();
  
  if (env.isProduction) {
    return 'https://canvango.com';
  }
  
  return env.origin;
};

/**
 * Debug environment information
 */
export const logEnvironmentInfo = () => {
  const env = getEnvironmentInfo();
  console.log('🌍 Environment Info:', {
    ...env,
    authRedirectUrl: getAuthRedirectUrl(),
    siteUrl: getSiteUrl(),
  });
};